import { useQuery } from "@tanstack/react-query";

import type { PortalUser } from "@/app/models";
import { consultationsQueriesStore } from "@/features/consultations/api";
import { useScheduleContext } from "@/features/consultations/contexts";
import { PROVIDER_PREFERENCE } from "@/shared/models/legacy-constants";

export const useAvailableDaysQuery = (userId?: PortalUser["patientId"]) => {
  const {
    language,
    scheduleDate: { dateFromMonth },
    provider,
    providerPreference,
    appointmentType: type,
    subscriptionId,
    appointmentToReschedule,
  } = useScheduleContext();

  const enabled = Boolean(
    provider ?? providerPreference === PROVIDER_PREFERENCE.EARLIEST,
  );

  return useQuery({
    ...consultationsQueriesStore.consultations.providers._ctx.availability._ctx.days(
      {
        date: dateFromMonth,
        providerId: provider?.id,
        userId,
        language,
        appointmentType: type,
        subscriptionId,
        originalDate: appointmentToReschedule?.startTime,
      },
    ),
    enabled,
  });
};
